<template>
  <div>
    <span v-for="(prize, i) in displayText" :key="i" class="prize-distribution">
      {{ prize }}{{ i != displayText.length - 1 ? ", " : "" }}
    </span>
    <span v-if="!hasStop" class="prize-distribution"> ...</span>
  </div>
</template>
<script>
import gql from "fraql";
import { useCurrency } from "@composables/masterdata/config";

export default {
  name: "AppShowPrizeDistribution",
  props: {
    prizeDistribution: {
      type: String,
      default() {
        return "";
      }
    }
  },
  fragments: {
    result: gql`
      fragment _ on Competition {
        id
        prizeDistribution
      }
    `
  },
  setup() {
    return {
      ...useCurrency()
    };
  },
  computed: {
    prizeItems() {
      return this.prizeDistribution.split(",");
    },
    // when prizeDistribution string ends with positive amount then the last prize will not stop the distribution.
    // If it ends with ',' or ',0' then the distribution will stop and all placed will get the last positive amount
    hasStop() {
      return !parseFloat(this.prizeItems[this.prizeItems.length - 1]) > 0;
    },
    displayText() {
      if (this.prizeItems.length == 0) return "";
      let prizesInCurrency = this.prizeItems
        .filter(i => i && parseFloat(i * 100) > 0.0)
        .map(amount => this.masterCurrency(parseFloat(amount * 100)));
      return prizesInCurrency;
    }
  }
};
</script>
